import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Theme } from "@/types";
import { fetchTheme } from "./thunk";

export interface ThemeState {
  theme: Partial<Theme>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: ThemeState = {
  theme: {},
  error: null,
  status: "idle"
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[themeSlice.name]
        };
      })
      .addCase(fetchTheme.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchTheme.fulfilled, (state, action) => {
        state.status = "idle";
        state.theme = action.payload;
      })
      .addCase(fetchTheme.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
